// extracted by mini-css-extract-plugin
module.exports = {"detailsTable":"DetailsTable_detailsTable__3ikIb","field":"DetailsTable_field__rfH0o","value":"DetailsTable_value__377j2","row":"DetailsTable_row__1RM4o"};